/**
 * Address of a building written as on an envelope: "Via Roma 1, Torino (TO)".
 * Missing parts are skipped, extra spaces removed, the province in capitals; a street or city
 * typed all in lower case gets its first letter capitalised.
 *
 * @param building building (or any object with address, city and province)
 * @returns the address, empty when the building has none
 */
export function formatBuildingAddress(building: { address?: string; city?: string; province?: string }): string {
  const street = capitalize(clean(building?.address));
  const city = capitalize(clean(building?.city));
  const province = clean(building?.province).toUpperCase();

  const place = [city, province ? `(${province})` : ""].filter((part) => part !== "").join(" ");
  return [street, place].filter((part) => part !== "").join(", ");
}

/** Text without leading/trailing and repeated spaces ("" for missing values) */
function clean(value: unknown): string {
  return value === null || value === undefined ? "" : `${value}`.replace(/\s+/g, " ").trim();
}

/** First letter in capitals, only when the text was typed all in lower case */
function capitalize(value: string): string {
  return value === value.toLowerCase() ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}
